/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./multiSearch.vue?vue&type=template&id=631af008&scoped=true"
import script from "./multiSearch.vue?vue&type=script&lang=js"
export * from "./multiSearch.vue?vue&type=script&lang=js"
import style0 from "./multiSearch.vue?vue&type=style&index=0&id=631af008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631af008",
  null
  
)

export default component.exports